/**
 * Big Win Class
 *
 *
 */

(function () {
  class BigWin extends PIXI.Container {
    constructor() {
      super();

      this.BIG_WIN = 1;
      this.HUGE_WIN = 2;
      this.MASSIVE_WIN = 3;
      this.EPIC_WIN = 4;
      this.MEGA_WIN = 5;
      this.COLOSSAL_WIN = 6;

      this._bigWinThreshold = 20;
      this._hugeWinThreshold = 50;
      this._massiveWinThreshold = 100;
      this._epicWinThreshold = 150;
      this._megaWinThreshold = 200;
      this._colossalWinThreshold = 500;

      this._totalDuration = 7600;
      this._winType = this.BIG_WIN;

      this.isActive = false;
      this.skipWin = false;
      this.allowSkipWin = false;
      this.currentLevel = 0;
      this.currentTitle = null;

      this.winAmount = 0;
      this.callback = undefined;
      this.countUpPromise = null;
      this.bigWinPromise = null;
    }

    getWinType(amount, stake) {
      if (amount >= stake * this._colossalWinThreshold) {
        return this.COLOSSAL_WIN;
      } else if (amount >= stake * this._megaWinThreshold) {
        return this.MEGA_WIN;
      } else if (amount >= stake * this._epicWinThreshold) {
        return this.EPIC_WIN;
      } else if (amount >= stake * this._massiveWinThreshold) {
        return this.MASSIVE_WIN;
      } else if (amount >= stake * this._hugeWinThreshold) {
        return this.HUGE_WIN;
      } else {
        return this.BIG_WIN;
      }
      0;
    }

    getBigWinThreshold() {
      return this._bigWinThreshold;
    }

    getHugeWinThreshold() {
      return this._hugeWinThreshold;
    }

    getMassiveWinThreshold() {
      return this._massiveWinThreshold;
    }

    getMegaWinThreshold() {
      return this._megaWinThreshold;
    }

    getEpicWinThreshold() {
      return this._epicWinThreshold;
    }

    getColossalWinThreshold() {
      return this._colossalWinThreshold;
    }

    willTriggerBigWin(amount, stake) {
      if (gameController.inBuyABonus) {
        return amount >= stake;
      } else {
        const threshold = stake * this._bigWinThreshold;
        return amount >= threshold;
      }
    }

    init() {
      this._dimScreen = resourceManager.get("bigWinDimObject");
      this._dimScreen.show(false);

      this._bigWinContainer = resourceManager.getContainer("bigWinContainer");
      this._bigWinContainer.visible = false;

      // Value Text Backing
      this._winAwardTextBacking = resourceManager.get("bigWin:awardTextBacking");
      this._winAwardTextBacking.visible = false;

      // NOTE: This uses a meter - you can't override the font size of the meter
      this._winAwardText = resourceManager.get("bigWin:awardText");
      this._winAwardText.visible = false;

      // winAwardText maxHeight config doesn't get passed through to the meter text so I'm setting it here manually
      this._winAwardText.textObject.setMaxHeight(this._winAwardText.Props.maxHeight);

      this._awardTextFinalPos = resourceManager.get("bigWin:awardTextFinalPos");
      this._awardTextStartPos = resourceManager.get("bigWin:awardTextStartPos");

      this._awardTextBackOffset = 10;

      // TEXT CONTAINERS \\

      //BIG WIN
      this._bigWinTextContainer = resourceManager.get("bigWin:bigWinTextContainer");
      this._bigWinTextContainer.visible = false;

      //HUGE WIN
      this._hugeWinTextContainer = resourceManager.get("bigWin:hugeWinTextContainer");
      this._hugeWinTextContainer.visible = false;

      //MASSIVE WIN
      this._massiveWinTextContainer = resourceManager.get("bigWin:massiveWinTextContainer");
      this._massiveWinTextContainer.visible = false;

      //EPIC WIN
      this._epicWinTextContainer = resourceManager.get("bigWin:epicWinTextContainer");
      this._epicWinTextContainer.visible = false;

      //MEGA WIN
      this._megaWinTextContainer = resourceManager.get("bigWin:megaWinTextContainer");
      this._megaWinTextContainer.visible = false;

      //COLOSSAL WIN
      this._colossalWinTextContainer = resourceManager.get("bigWin:colossalWinTextContainer");
      this._colossalWinTextContainer.visible = false;

      this._bigwinYouWon = resourceManager.get("bigWin:bigwinYouWon");
      this._bigwinYouWon.visible = false;

      //BURST ANIMATIONS
      this._topBurst = resourceManager.get("bigWin:topBurst");
      this._topBurst.visible = false;
      this._middleBurst = resourceManager.get("bigWin:middleBurst");
      this._middleBurst.visible = false;
      this._bottomBurst = resourceManager.get("bigWin:bottomBurst");
      this._bottomBurst.visible = false;

      // this.burst = resourceManager.get("bigWin:Burst");
      // this.burst.visible = false;

      this._emitterCoins = particleManager.createEmitter("bigwin_emitter_4", "bigWin:particlesContainer", 0, 0, false);
      this._emitterCoins.particleEmitter.emit = false;
      this._emitterCoins.visible = false;

      this._emitterDiamondSmall = particleManager.createEmitter(
        "bigwin_emitter_2",
        "bigWin:particlesContainer",
        0,
        -100,
        false
      );
      this._emitterDiamondSmall.particleEmitter.emit = false;
      this._emitterDiamondSmall.visible = false;

      this._allEmitters = [this._emitterCoins, this._emitterDiamondSmall];

      this._skipBigWinBox = resourceManager.get("bigWin:skipBigWinBox");

      this._skipBigWinBox.alpha = 0;
      this._skipBigWinBox.visible = false;
      this._skipBigWinBox.interactive = false;

      this._cappedWinPopup = resourceManager.get("maxWinPopup");
      this._cappedWinPopup.visible = false;
      this._cappedWinPopupButton = resourceManager.get("maxWinPopup:continueButton");
      this._cappedWinPopupButton.interactive = false;

      this.gameContainer = resourceManager.getContainer("gameContainer");
      this.btnContainer = resourceManager.getContainer("gameButtonContainer");

      this.presentLevelData = [
        {
          level: this.BIG_WIN,
          previousTitle: null,
          nextTitle: this._bigWinTextContainer,
          threshold: null,
          nextThreshold: null,
          emittersToStop: [],
          emittersToStart: [this._emitterCoins, this._emitterDiamondSmall],
        },
        {
          level: this.HUGE_WIN,
          previousTitle: this._bigWinTextContainer,
          nextTitle: this._hugeWinTextContainer,
          threshold: this.getHugeWinThreshold(),
          nextThreshold: this.getMassiveWinThreshold(),
          emittersToStop: [],
          emittersToStart: [],
        },
        {
          level: this.MASSIVE_WIN,
          previousTitle: this._hugeWinTextContainer,
          nextTitle: this._massiveWinTextContainer,
          threshold: this.getMassiveWinThreshold(),
          nextThreshold: this.getEpicWinThreshold(),
          emittersToStop: [],
          emittersToStart: [],
        },
        {
          level: this.EPIC_WIN,
          previousTitle: this._massiveWinTextContainer,
          nextTitle: this._epicWinTextContainer,
          threshold: this.getEpicWinThreshold(),
          nextThreshold: this.getMegaWinThreshold(),
          emittersToStop: [],
          emittersToStart: [],
        },
        {
          level: this.MEGA_WIN,
          previousTitle: this._epicWinTextContainer,
          nextTitle: this._megaWinTextContainer,
          threshold: this.getMegaWinThreshold(),
          nextThreshold: this.getColossalWinThreshold(),
          emittersToStop: [],
          emittersToStart: [],
        },
        {
          level: this.COLOSSAL_WIN,
          previousTitle: this._megaWinTextContainer,
          nextTitle: this._colossalWinTextContainer,
          threshold: this.getColossalWinThreshold(),
          nextThreshold: null,
          emittersToStop: [],
          emittersToStart: [],
        },
      ];
    }

    isBigWinActive() {
      return this.isActive;
    }

    // TODO !!!!!!!!!!!
    async showCappedWinPopup(callback) {
      this._cappedWinPopupShowing = true;
      this._cappedWinPopup.visible = true;
      this._cappedWinPopup.alpha = 0;
      this.isActive = true;
      const self = this;
      await timerManager.addTimer(500, function (progress) {
        self._dimScreen.show(true);
        self._dimScreen.alpha = progress * 0.6;
        self._cappedWinPopup.alpha = progress;
      });

      self._dimScreen.show(true);
      self._dimScreen.alpha = 0.6;
      self._cappedWinPopup.alpha = 1;
      self._cappedWinPopupButton.interactive = true;

      const hideCappedWinPopup = () => {
        self._cappedWinPopupShowing = true;
        self._cappedWinPopup.visible = false;
        self._dimScreen.show(false);
        self._cappedWinPopupButton.interactive = false;
        self._cappedWinPopupButton.touchend = self._cappedWinPopupButton.mouseup = function () {};
        callback();
      };
      self._cappedWinPopupButton.touchend = self._cappedWinPopupButton.mouseup = hideCappedWinPopup;

      const sp = gdk.getServerParser();
      const inReplayOrRewatch = sp._inReplayMode || sp._inRewatchMode;

      if (inReplayOrRewatch) {
        timerManager.delayAsync(5000, undefined, () => {
          if (self._cappedWinPopupShowing) {
            hideCappedWinPopup();
          }
        });
      }
    }

    start(winAmount, capped, cbOnPresentLevel, cbOnCountUpFinished, cbWhenFinished, whereFrom = "") {
      // capped isnt needed in this game and the pop up shown much earlier
      this.whereFrom = whereFrom;

      if (capped) {
        this.showCappedWinPopup(() => {
          this.doBigWin(winAmount, cbOnPresentLevel, cbOnCountUpFinished, cbWhenFinished);
        });
      } else {
        this.doBigWin(winAmount, cbOnPresentLevel, cbOnCountUpFinished, cbWhenFinished);
      }
    }

    getAmountToCountUp(nextThreshold, threshold) {
      let amountToCountUp = 0;

      if (nextThreshold === null && threshold === null) {
        // return 0
      } else if (nextThreshold === null) {
        // got to the highest stage
        amountToCountUp = this.winAmount - this._bigWinCurrentStake * threshold;
      } else {
        amountToCountUp =
          Math.min(this._bigWinCurrentStake * nextThreshold, this.winAmount) - this._bigWinCurrentStake * threshold;
      }
      return amountToCountUp;
    }

    getBigWinPromise() {
      return this.bigWinPromise;
    }

    async doBigWin(winAmount, cbOnPresentLevel, cbOnCountUpFinished, cbWhenFinished) {
      let doBigWinResolver = null;
      this.bigWinPromise = new Promise((resolve) => {
        doBigWinResolver = resolve;
      });

      this.winAmount = winAmount;
      this.isActive = true;
      this.skipWin = false;
      this.allowSkipWin = false;

      // lets dim the screen
      this._dimScreen.show(true);
      this._dimScreen.alpha = 0;
      gsap.to(this._dimScreen, {
        duration: 0.3,
        alpha: 0.6,
      });

      this._bigWinCurrentStake = gameController.globalHelperGetBaseStake();

      this._winType = this.getWinType(this.winAmount, this._bigWinCurrentStake);
      let duration = this._totalDuration / this._winType;
      this.visible = true;

      await this.intro();

      for (let i = 0; i < this.presentLevelData.length; i++) {
        const presentLevelData = this.presentLevelData[i];
        const { threshold, level, nextTitle, nextThreshold } = presentLevelData;

        const isLast = this.winAmount <= this._bigWinCurrentStake * nextThreshold;

        if (isLast) {
          const rangeSize = this._bigWinCurrentStake * nextThreshold - this._bigWinCurrentStake * threshold;
          const progressIntoRange = this.winAmount - this._bigWinCurrentStake * threshold;

          const percetageOfThresholdToCountup = progressIntoRange / rangeSize;
          duration = duration * percetageOfThresholdToCountup;
        }

        if (this.winAmount >= this._bigWinCurrentStake * threshold) {
          this.currentLevel = level;
          this.currentTitle = nextTitle;
          if (cbOnPresentLevel) {
            cbOnPresentLevel();
          }
          await this.presentLevel(presentLevelData, duration);
        }
      }

      !this.skipWin && musicManager.endBigWin();

      if (cbOnCountUpFinished) {
        cbOnCountUpFinished();
      }

      // disable the skip
      this._skipBigWinBox.interactive = false;
      this.allowSkipWin = false;

      await this.showFinalResult();

      await this.outro();

      this.isActive = false;
      this.visible = false;

      if (cbWhenFinished) {
        cbWhenFinished();
      }

      doBigWinResolver();
      this.bigWinPromise = null;
    }

    canSkip() {
      return this.isActive && !this.skipWin && this.allowSkipWin;
    }

    degreesToRadians(degrees) {
      return degrees * (Math.PI / 180);
    }

    // not using the one from game, because we have listenForSkipWin
    // and i cant for the life of me work out how to make it generic for now
    async tweenFromToAsync(targets, fromVars, toVars, tweenInfo = null) {
      let resolver = null;
      const tweenPromise = new Promise((resolve) => {
        resolver = resolve;
      });

      const origOnComplete = toVars.onComplete;
      toVars.paused = true;
      if (toVars.listenForSkipWin === true) {
        const self = this;
        toVars.onUpdate = function () {
          if (self.skipWin) {
            this.progress(1);
          }
        };
      }
      toVars.listenForSkipWin = null;
      delete toVars.listenForSkipWin;
      toVars.onComplete = () => {
        if (origOnComplete) {
          origOnComplete();
        }
        resolver();
      };

      const tween = gsap.fromTo(targets, fromVars, toVars);
      tween.time(0).restart(true);

      if (tweenInfo) {
        tweenInfo.tween = tween;
        tweenInfo.resolver = resolver;
        tweenInfo.promise = tweenPromise;
      }

      return tweenPromise;
    }

    async scaleInBursts() {
      this._topBurst.visible = true;
      this._middleBurst.visible = true;
      this._bottomBurst.visible = true;

      await Promise.all([
        this.tweenFromToAsync(
          this._topBurst.scale,
          {
            x: 0,
            y: 0,
          },
          {
            x: 1,
            y: 1,
            duration: 0.5,
          }
        ),
        this.tweenFromToAsync(
          this._middleBurst.scale,
          {
            x: 0,
            y: 0,
          },
          {
            x: 1,
            y: 1,
            duration: 0.5,
          }
        ),
        this.tweenFromToAsync(
          this._bottomBurst.scale,
          {
            x: 0,
            y: 0,
          },
          {
            x: 1,
            y: 1,
            duration: 0.5,
          }
        ),
      ]);
    }

    async fadeInBursts() {
      await Promise.all([
        this.tweenFromToAsync(
          this._topBurst,
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.5,
          }
        ),
        this.tweenFromToAsync(
          this._middleBurst,
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.5,
          }
        ),
        this.tweenFromToAsync(
          this._bottomBurst,
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.5,
          }
        ),
      ]);
    }

    async scaleInTitle(title, listenForSkipWin = false) {
      title.alpha = 1;
      title.visible = true;
      await this.tweenFromToAsync(
        title.scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 0.8,
          y: 0.8,
          listenForSkipWin: listenForSkipWin,
          duration: 0.5,
        }
      );
    }

    async moveInWinAwardTextBacking() {
      this._winAwardTextBacking.visible = true;

      await Promise.all([
        this.tweenFromToAsync(
          this._winAwardTextBacking,
          {
            x: this._awardTextStartPos.position.getX(),
            y: this._awardTextStartPos.position.getY(),
          },
          {
            x: this._awardTextFinalPos.position.getX(),
            y: this._awardTextFinalPos.position.getY(),
            duration: 0.333,
          }
        ),
        this.tweenFromToAsync(
          this._winAwardTextBacking,
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.2,
          }
        ),
      ]);
    }

    async moveOutWinAwardTextBacking() {
      await Promise.all([
        this.tweenFromToAsync(
          this._winAwardTextBacking,
          {
            x: this._awardTextFinalPos.position.getX(),
            y: this._awardTextFinalPos.position.getY(),
          },
          {
            x: this._awardTextStartPos.position.getX(),
            y: this._awardTextStartPos.position.getY(),
            duration: 0.5,
          }
        ),
      ]);

      this._winAwardTextBacking.visible = false;
      this._winAwardText.set(0);
      this._winAwardText.visible = false;
    }

    startRotatingBursts() {
      // start the bursts rotating
      this._topBurst.rotation = 0;
      this._middleBurst.rotation = 0;
      this._bottomBurst.rotation = 0;

      this.rotateTopBurstTween = gsap.to(this._topBurst, {
        duration: 12,
        rotation: this.degreesToRadians(359),
        repeat: -1,
        ease: "none",
      });
      this.rotateMiddleBurstTween = gsap.to(this._middleBurst, {
        duration: 12,
        rotation: this.degreesToRadians(-359),
        repeat: -1,
        ease: "none",
      });
      this.rotateBottomBurstTween = gsap.to(this._bottomBurst, {
        duration: 12,
        rotation: this.degreesToRadians(359),
        repeat: -1,
        ease: "none",
      });
    }

    stopRotatingBursts() {
      if (this.rotateTopBurstTween) {
        this.rotateTopBurstTween.kill();
        this.rotateTopBurstTween = null;
      }
      if (this.rotateMiddleBurstTween) {
        this.rotateMiddleBurstTween.kill();
        this.rotateMiddleBurstTween = null;
      }
      if (this.rotateBottomBurstTween) {
        this.rotateBottomBurstTween.kill();
        this.rotateBottomBurstTween = null;
      }
    }

    // Big win intro - this can't be skipped
    async intro() {
      musicManager.playBigWin();

      const firstLevelData = this.presentLevelData[0];

      // lets kick off the 1st emitter(s)
      firstLevelData.emittersToStart.forEach((emitter) => {
        emitter.particleEmitter.emit = true;
        emitter.visible = true;
      });

      // set the count up to show big win starting value and hide
      // dont use the nice win threshold, as nice win comes in straight away, use the big win, as this is when
      // the title switches and exits the presentLevel
      let amountToCountUp = Math.min(this._bigWinCurrentStake * this.getHugeWinThreshold(), this.winAmount);

      this._winAwardText.set(0);
      this._winAwardText.visible = true;
      const duration = this._totalDuration / this._winType;
      this.countUpPromise = this.countUp(amountToCountUp, duration);

      this.startRotatingBursts();

      // make ourselves visible
      this._bigWinContainer.visible = true;

      this.previousTitle = null;
      this.currentTitle = firstLevelData.nextTitle;

      // lets start bringing stuff in
      const scaleInBurstsPromise = this.scaleInBursts();
      const fadeInBurstsPromise = this.fadeInBursts();
      const scaleInTitlePromise = this.scaleInTitle(this.currentTitle);
      const moveInWinAwardTextBackingPromise = this.moveInWinAwardTextBacking();

      // wait for all the intro tweens to finish
      await Promise.all([
        scaleInBurstsPromise,
        fadeInBurstsPromise,
        scaleInTitlePromise,
        moveInWinAwardTextBackingPromise,
      ]);
    }

    async countUp(amountToCountUp, duration) {
      this._winAwardText.countUp;

      this.countUpResolver = null;
      const countUpPromise = new Promise((resolve) => {
        this.countUpResolver = resolve;
      });

      this._winAwardText.countUp(amountToCountUp, duration, () => {
        this.countUpResolver();
        this.countUpResolver = null;
      });

      await countUpPromise;
    }

    pulseTitle(title) {
      this.pulseTitleTween = gsap.fromTo(
        title.scale,
        {
          x: 0.8,
          y: 0.8,
        },
        {
          x: 1,
          y: 1,
          duration: 0.15,
          repeat: -1,
          yoyo: true,
        }
      );
    }

    stopPulsingTitle() {
      this.pulseTitleTween.kill();
    }

    pulseWinAwardText() {
      this.pulseWinAwardTextTween = gsap.fromTo(
        this._winAwardText.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 1.1,
          y: 1.1,
          duration: 0.15,
          repeat: -1,
          yoyo: true,
        }
      );
    }

    stopPulsingWinAwardText() {
      this.pulseWinAwardTextTween.kill();
      this._winAwardText.scale.x = 1;
      this._winAwardText.scale.y = 1;
    }

    async scaleOutAndFadeOffTitle(title, listenForSkipWin = false) {
      await Promise.all([
        this.tweenFromToAsync(
          title.scale,
          {
            x: title.scale.x,
            y: title.scale.y,
          },
          {
            x: 3,
            y: 3,
            listenForSkipWin: listenForSkipWin,
            duration: 0.75,
          }
        ),
        this.tweenFromToAsync(
          title,
          {
            alpha: 1,
          },
          {
            alpha: 0,
            listenForSkipWin: listenForSkipWin,
            duration: 0.5,
          }
        ),
      ]);
    }

    async presentLevel(levelData, duration) {
      const { previousTitle, nextTitle, threshold, nextThreshold, emittersToStop, emittersToStart } = levelData;

      if (previousTitle) {
        this.stopPulsingTitle();
        this.scaleOutAndFadeOffTitle(previousTitle, true);
      }

      emittersToStop.forEach((emitter) => {
        emitter.particleEmitter.emit = false;
      });

      emittersToStart.forEach((emitter) => {
        emitter.particleEmitter.emit = true;
        emitter.visible = true;
      });

      this._winAwardText.visible = true;

      //PLAY THE WIN COUNT UP SOUND
      this._playWinCountUpSound();

      if (!this.skipWin) {
        if (this.countUpPromise === null) {
          const amountToCountUp = this.getAmountToCountUp(nextThreshold, threshold);
          this.countUpPromise = this.countUp(amountToCountUp, duration);
        } else {
          // already have a promise, this will be from the intro
        }
      }

      if (previousTitle && nextTitle) {
        if (!this.skipWin) {
          soundManager.play("bigwinUpgrade");
        }
        const scaleInTitlePromise = this.scaleInTitle(nextTitle, true);
        await scaleInTitlePromise;
      }

      if (nextTitle) {
        this.pulseTitle(nextTitle);
      }

      if (!this.skipWin) {
        this.allowSkipWin = true;
        this._skipBigWinBox.interactive = true;
        this._skipBigWinBox.visible = true;
        this._skipBigWinBox.mousedown = this._skipBigWinBox.touchstart = this.skip.bind(this);
      }

      // and then we need to wait for the count up to finish
      await this.countUpPromise;
      this.countUpPromise = null;
    }

    _playWinCountUpSound() {
      if (this.countUpSound !== null) {
        this.countUpSound = soundManager.play("winCountUp", () => this._playWinCountUpSound());
      }
    }

    async showFinalResult() {
      soundManager.stop("winCountUp");
      soundManager.stop("bigWinLoop");
      this.countUpSound = null;
      soundManager.play("winCountUpEnd");
      soundManager.play("bigWinCountUpEnd");
      this.pulseWinAwardText();
      await timerManager.delayAsync(1500);
      this.stopPulsingWinAwardText();
    }

    async fadeOut() {
      await Promise.all([
        this.tweenFromToAsync(
          this._bigWinContainer,
          {
            alpha: 1,
          },
          {
            alpha: 0,
            duration: 0.5,
          }
        ),
        this.tweenFromToAsync(
          this._dimScreen,
          {
            alpha: 0.6,
          },
          {
            alpha: 0,
            duration: 0.5,
          }
        ),
      ]);

      this._bigWinContainer.visible = false;
      this._bigWinContainer.alpha = 1;
    }

    stopAllEmitters() {
      this._allEmitters.forEach((emitter) => {
        emitter.particleEmitter.emit = false;
        emitter.visible = false;
      });
    }

    async outro() {
      // start fading everything out
      const fadeOutPromise = this.fadeOut();
      const scaleOutAndFadeOffTitlePromise = this.scaleOutAndFadeOffTitle(this.currentTitle);
      const moveOutWinAwardTextBackingPromise = this.moveOutWinAwardTextBacking();
      await Promise.all([
        fadeOutPromise, //
        scaleOutAndFadeOffTitlePromise,
        moveOutWinAwardTextBackingPromise,
      ]);

      // now we cant be seen
      // clean up stuff
      this.stopAllEmitters();
      this.stopRotatingBursts();
      this._topBurst.visible = false;
      this._middleBurst.visible = false;
      this._bottomBurst.visible = false;
      this._dimScreen.show(false);

      this._skipBigWinBox.visible = false;
    }

    skip() {
      if (this.canSkip()) {
        this._skipBigWinBox.interactive = false;
        this.allowSkipWin = false;
        this._winAwardText.cancelCountUp();
        this._winAwardText.set(this.winAmount);
        musicManager.endBigWin();
        this.skipWin = true;
      }
    }
  }

  var bigWinCreator = function (json) {
    return new BigWin();
  };

  var bigWinInitialiser = function (json, bigWin) {};

  var bigWinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType("BigWin", bigWinCreator, bigWinInitialiser, bigWinFilesRequired);
})();
